import dayjs from 'dayjs';
import React, {
  createContext,
  FC,
  ReactNode,
  useContext,
  useState,
} from 'react';
import { DatePattern } from 'utils/constant';

interface HeaderProviderProps {
  children: ReactNode;
}

export interface DateType {
  start: string;
  end: string;
}

export interface HeaderContextType {
  date: string;
  setDate: React.Dispatch<React.SetStateAction<string>>;
  rangeDate: DateType;
  setRangeDate: React.Dispatch<React.SetStateAction<DateType>>;
}

const HeaderContext = createContext<HeaderContextType>({} as HeaderContextType);

export const useHeaderContext = () => useContext(HeaderContext);

export const HeaderProvider: FC<HeaderProviderProps> = ({ children }) => {
  const [date, setDate] = useState<string>(dayjs().format(DatePattern.DATE));
  const [rangeDate, setRangeDate] = useState<DateType>({
    start: dayjs().subtract(6, 'day').format(DatePattern.DATE),
    end: dayjs().format(DatePattern.DATE),
  });

  return (
    <HeaderContext.Provider value={{ date, setDate, rangeDate, setRangeDate }}>
      {children}
    </HeaderContext.Provider>
  );
};
